const publicModule = {
  title: "ประเภท",
  pageTitle: "แพลตฟอร์มการจัดการบริการการทำงานของยานพาหนะ",
  resMsg: "การยืนยันล้มเหลว กรุณาล็อคอินสู่ระบบอีกครั้ง",
  cancel: "ยกเลิก",
  define: "ยืนยัน",
  close: "ปิด",
  startUp: "เริ่มต้น",
  tips: "เคล็ดลับ",
  deleteTips: "โปรดตรวจสอบรายการที่จะลบ",
  ordinaryDeleteTips: "ผู้ใช้ทั่วไปสามารถลบรายการที่กำหนดเองได้เท่านั้น",
  administratorsDeleteTips: "ผู้ดูแลระบบสามารถลบเฉพาะการซ่อมแซมทั่วไปและการซ่อมแซมอื่น ๆ",
  deleteItemTips: "คุณต้องการลบตัวเลือกหรือไม่?",
  deleteItemTips: "คุณต้องการลบตัวเลือกหรือไม่?",
  updateTips: "โปรดตรวจสอบรายการที่จะอัปเดต",
  viewTips: "โปรดเลือกรายการที่คุณต้องการดู",
  createTips: "โปรดเลือกรายการที่ต้องการเพิ่ม",
  noSelectTips: "Please select the vehnoSelectTipsicle to bind",
  operationTips: "โปรดเลือกรายการที่คุณต้องการใช้งาน",
  createSuccess: "สร้างสำเร็จ",
  updateSuccess: "อัปเดตเรียบร้อยแล้ว",
  deleteSuccess: "ลบสำเร็จแล้ว",
  setSuccess: "ตั้งค่าความสำเร็จ",
  add: "เพิ่ม",
  delete: "ลบ",
  update: "อัปเดต",
  create: "เพิ่ม",
  search: "ค้นหา",
  clear: "ลบ",
  more: "เพิ่มเติม",
  open: "ขยาย",
  packUp: "ย่อ",
  note: "หมายเหตุ",
  others: "อื่น ๆ",
  operation: "รายละเอียด",
  view: "ดู",
  revoke: "Cancel",
  createTime: "วันที่สร้าง",
  usertypeList: {
    internalUsers: "ผู้ใช้ภายใน",
    externalUsers: "ผู้ใช้ภายนอก"
  },
  startTime: "เวลาเริ่มต้น",
  endTime: "เวลาสิ้นสุด",
  quickQuery: "Quick query",
  quickQueryLabelWidth: "90px",
  organizationName: "Organization name",
  licensePlate: "ป้ายทะเบียน",
  licensePlatewidth1: "95px",
  importDialog: {
    title: "นำเข้า",
    file: "ไฟล์",
    browse: "เรียกดู",
    note: "หมายเหตุ: หากจำเป็นต้องเลือกไฟล์ที่อัปโหลดใหม่ก่อนที่จะอัปโหลด",
    downloadTemplate: "ดาวน์โหลดเทมเพลต",
    success: "ประสบความสำเร็จ",
    uploadSuccess: "อัปโหลดไฟล์เรียบร้อยแล้ว",
    selectFile: "โปรดเลือกอัปโหลดไฟล์",
    restFile: "ไฟล์นี้ถูกอัปโหลดแล้วโปรดเลือกไฟล์อัปโหลดอีกครั้ง"
  },
  reset: "รีเซ็ต",
  import: "นำเข้า",
  basicMode: "โหมดพื้นฐาน",
  default: "ค่าเริ่มต้น",
  green: "เขียว",
  modelName: "ชื่อโมเดล",
  other: {
    yes: "ใช่",
    no: "ไม่",
    dataTime: "เวลาข้อมูลที่รายงาน",
    area: "Use area",
    voltage: "Constant voltage",
    isDriving: "Driving or not",
    can: "CAN data",
    gpsMileage: "GPS mileage",
    signalStrength: "Signal strength",
    speed: "ความเร็ว",
    vSpeed: "ความเร็ว",
    noGroup: "No group",
    finallyData: "รายงานข้อมูลล่าสุดก่อนรถออฟไลน์",
    textIndent: "15px"
  },
  timeError: "เวลาเริ่มต้นต้องไม่เกินเวลาสิ้นสุด， โปรดเลือกใหม่",
  unbind: "การเลิกรวมกลุ่ม",
  bind: "ผูกพัน",
  gender: "Gender",
  male: "Male",
  female: "Female",
  userName: "ชื่อผู้ใช้",
  mobile: "เบอร์มือถือ",
  enable: "เปิดใช้งาน",
  ban: "ปิดการใช้งาน",
  all: "ทั้งหมด",
  uploadImageFailed: "การอัปโหลดรูปภาพล้มเหลว， โปรดลองอีกครั้งในภายหลัง!",
  viewDetail: "ข้อมูล",
  defaultpassword: "รหัสผ่านเริ่มต้น: 12345678",
  remarkDescription: "You can type up to 200 words",
  uploading: "ไฟล์ขึ้นและลง",
  obdCode: "หมายเลขอุปกรณ์",
  lengthMessage: "ความยาวอักษรต้องไม่เกิน",
  expirationTime: "วันที่สิ้นสุดการใช้งาน",
  driveSmallPlate: "หมายเลข MCB",
  upgradeTime: "เวลาที่อัปเกรด",
  maxValue: "มากที่สุด",
  minValue: "น้อยที่สุด",
  checkCarSelect: "เลือกยานพาหนะ",
  chose: "เลือก",
  choseObd: "กำหนดสิทธิ์อุปกรณ์",
  setting: "การตั้งค่า",
  terminal: "หมายเลข S/N",
  firmwareVersion: "เวอร์ชันเฟิร์มแวร์",
  mpuVersion: "เวอร์ชัน MPU",
  changeAlarm: "เปลี่ยนการแจ้งเตือน",
  wakeUpOnTime: "Wake up on time",
  cancelTaskTips: "คุณต้องการยกเลิกงานหรือไม่",
  cancelAllTaskTips: "คุณต้องการยกเลิกงานที่เลือกหรือไม่?",
  clickCancle: "คลิกเพื่อยกเลิก",
  fail: "ล้มเหลว",
  success: "สำเร็จ",
  noResponse: "ไม่มีการตอบสนอง",
  description: "คำอธิบาย",
  sim: "หมายเลขซิมอุปกรณ์",
  iccid: "ICCID",
  simWidth: "120px",
  noSetting: "Not set",
  opens: "เปิด",
  operationStatus: "สถานะ",
  operTarget: "เป้าหมาย",
  register: "ลงทะเบียน",
  forget: "ลืมรหัสผ่าน",
  changePassword: "เปลี่ยนรหัสผ่าน",
  changeMobile: "เปลี่ยนหมายเลขมือถือ",
  account: "บัญชีผู้ใช้",
  vehicle: "ยานพาหนะ",
  fence: "ขอบเขตแจ้งเตือน",
  newCreate: "สร้าง",
  edit: "แก้ไข",
  cancelTask: "ยกเลิกงาน",
  noCommad: "โปรดเลือกรายการคำสั่ง",
  normalMode: "โหมดการทำงานปกติ",
  busSleep: "Bus sleep",
  lockCarOpen: "Lock car",
  cancelLockCar: "Cancel lock",
  commandVehicle: "คำสั่งอุปกรณ์ OBD",
  command: "ชุดคำสั่ง",
  taskInformation: "ข้อมูลงาน",
  noNormalMode: "โปรดเลือกโหมด sleep",
  confirmUrl: "โปรดตรวจสอบที่อยู่การเชื่อมต่อของอุปกรณ์ OBD อย่างรอบคอบเพื่อป้องกันการสูญเสียการเชื่อมต่อของอุปกรณ์ OBD",
  IPorDomain: "IP หรือโดเมน",
  export: "ส่งออก",
  obdNote: "หมายเหตุ: เฉพาะหมายเลขอุปกรณ์ OBD ที่จุดเริ่มต้นของ v2a2 เท่านั้นที่สามารถเลือกบอร์ดขับขี่ได้",
  formLoadFailed: "โหลดฟอร์มไม่สำเร็จ",
  baseInfo: "ข้อมูลพื้นฐาน",
  totalmileage:"ระยะรวม",
  duration:"ช่วงเวลา",
  consumptionrate:"อัตราการบริโภค",
  averagespeed:"ความเร็วเฉลี่ย",
  totalidletime:"เวลาว่างทั้งหมด",
  vehicletype:"ประเภทรถ",
  currentvehiclestatus:"สถานะรถปัจจุบัน",
  models:"นางแบบ",
  latitude:"ละติจูด",
  longitude:"ลองจิจูด",
  maxSpeed:"ความเร็วสูงสุด",
  startldletime:"เริ่มเวลาว่าง",
  endldletime:"สิ้นสุดเวลาว่าง",
  totalldletime:"เวลาว่างทั้งหมด",
  Percentpertrip:"เปอร์เซ็นต์ต่อการเดินทาง",
  Totalfueluse:"การใช้เชื้อเพลิงทั้งหมด",
  averageconsumption:"การบริโภคเฉลี่ย",
  lastlocation:"ตำแหน่งสุดท้าย",
  lasttime:"ครั้งสุดท้าย",
  vibrationlocation:"ตำแหน่งการสั่นสะเทือน",
  vibrationtime:"เวลาการสั่นสะเทือน",
  ignitionlocation:"ตำแหน่งจุดระเบิด",
  ignitiontime:"เวลาจุดระเบิด",
  overspeedtime:"เวลาเร่งความเร็ว",
  timesofoverspeed:"ความเร็ว",
  geofencename:"ชื่อรั้ว",
  status:"รั้วภายในและภายนอก",
  entertime:"เวลานำเข้า",
  durationsig:"ระยะเวลาของการพักในรั้วดิน",
  exittime:"เวลาออก",
  durationsog:"ระยะเวลาของการใช้ชีวิตนอกกำแพง",
  faultgroup:"กลุ่มความผิด",
  faultcode:"รหัสความล้มเหลว",
  faultdescription:"รายละเอียดข้อบกพร่อง",
  diagnosticstartdatatime:"วันที่เริ่มต้นของการวินิจฉัย",
  diagnosticenddatatime:"วันที่สิ้นสุดของการวินิจฉัย",
  carnum:"จำนวนของยานพาหนะ",
  offlinenum:"หมายเลขอุปกรณ์ออฟไลน์",
  parkengineon:"จำนวนครั้งที่จอดรถเครื่องยนต์เปิด",
  parkengineoff:"จำนวนครั้งที่จอดรถเครื่องยนต์ปิด",
  normalspeeddrive:"ความเร็วปกติ",
  overspeeddrive:"ขับรถเร็วกว่า",
  offline:"ออฟไลน์",
  online:"ออนไลน์",
  maintenance:"การดูแลรถ",
   repair:"ซ่อมรถ"
} 
export default publicModule